<p-menu [model]="menuItems" [style]="{width: '100%'}" styleClass="w-full admin-nav-menu"></p-menu>
